import clsx from "clsx";
import { FC } from "react";

import { PIC } from "@ryde/assets";
import { isLiveMapFullDisplayMode, LiveMapDisplayModeEnum } from "@ryde/shared";

interface ILiveMapDisplayModeIcon {
  displayMode: LiveMapDisplayModeEnum;
  className?: string;
}

export const LiveMapDisplayModeIcon: FC<ILiveMapDisplayModeIcon> = ({
  displayMode,
  className,
}) => {
  const isFull = isLiveMapFullDisplayMode(displayMode);

  return (
    <PIC.MapModeSVG
      className={clsx(
        "live-map-display-mode-icon",
        isFull
          ? "live-map-display-mode-icon--active"
          : "live-map-display-mode-icon--muted",
        className,
      )}
      aria-hidden
    />
  );
};
